// extracted by mini-css-extract-plugin
module.exports = {"top":"ConnectedDataReport-module__top___12ogq","table":"ConnectedDataReport-module__table___1h0wQ"};